import(/* webpackMode: "eager" */ "/workspace/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/workspace/src/app/globals.css");
;
import(/* webpackMode: "eager" */ "/workspace/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.js\",\"import\":\"Inter\",\"arguments\":[{\"subsets\":[\"latin\"]}],\"variableName\":\"inter\"}");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/src/components/AppChrome.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/src/components/dev/DebugFsMount.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/src/components/panels/ThreadPanelHost.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/src/components/PortalBrowserBranding.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/src/components/ToastCenter.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["AuthProvider"] */ "/workspace/src/context/AuthContext.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["InboxNotificationsProvider"] */ "/workspace/src/context/InboxNotificationsContext.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["PortalProvider"] */ "/workspace/src/context/PortalContext.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["PushNotificationsProvider"] */ "/workspace/src/context/PushNotificationsContext.jsx");
